import { Translations } from './translations'

export const ja: Translations = {
  // Header
  title: 'GPT Clicker',
  subtitle: 'AI Training Tycoon',
  settings: '設定',

  // Resources
  resources: 'リソース',
  money: 'お金',
  energy: 'エネルギー',
  compute: 'コンピューティング',
  quality: 'クオリティ',
  totalUsers: 'ユーザー総数',
  price: '価格',
  research: '研究',

  // Actions
  train: 'トレーニング',
  trainCost: 'コスト',
  qualityGain: 'クオリティ',
  inference: '推論',
  needUsers: 'ユーザーが必要!',
  usersWaiting: 'ユーザーが待機中',
  qualityToAttract: 'クオリティ > 40% で引き付け可能',
  researchAction: '研究',
  unlocksAfter: 'ここまで進むと解除:',
  computeSpent: 'コンピューティング使用量',
  cost: 'コスト',
  compShort: 'コンピ',
  energyShort: 'エネ',

  // Hardware
  hardware: 'ハードウェア',
  computePerSec: 'コンピューティング/秒',
  usesEnergy: '使用',
  devicesTotal: 'デバイス合計',

  // Models
  training: 'トレーニング',
  yourModels: 'あなたのモデル',
  params: 'パラメータ',
  maxUsers: '最大ユーザー数',
  trainCost2: 'トレーニングコスト',
  unlocked: '解除済み',
  researchPoints: '研究',

  // Upgrades
  upgrades: 'アップグレード',
  upgradesLockedMsg: 'モデルを50%のクオリティまでトレーニングしてアップグレードを解除',
  max: '最大',
  all: 'すべて',
  
  // Upgrade tiers
  tierGarage: 'ガレージ',
  tierGarageDesc: '始まり',
  tierStartup: 'スタートアップ',
  tierStartupDesc: 'GPT-1時代',
  tierScaleUp: 'スケールアップ',
  tierScaleUpDesc: 'GPT-2/3時代',
  tierEnterprise: 'エンタープライズ',
  tierEnterpriseDesc: 'ChatGPT時代',
  tierHyperscale: 'ハイパースケール',
  tierHyperscaleDesc: 'GPT-4時代',
  tierGlobal: 'グローバル',
  tierGlobalDesc: '競争時代',
  tierSuperintelligence: 'スーパーインテリジェンス',
  tierSuperintelligenceDesc: 'GPT-5+時代',
  tierSingularity: 'シンギュラリティ',
  tierSingularityDesc: 'AGI/ASI時代',

  // Footer
  computeSpentStat: 'コンピューティング使用量',
  time: '時間',
  resetGame: 'ゲームをリセット',
  resetConfirm: 'すべての進行をリセットしてもよろしいですか?',
  pause: '一時停止',
  resume: '再開',

  // Event Log
  eventLog: 'イベントログ',
  welcome: 'GPT Clickerへようこそ! 開始するにはモデルをトレーニングしてください。',

  // Price
  market: 'マーケット',
  pricePerMillion: '$/100万トークン',

  // Tags
  tagEnergy: 'エネ',
  tagCompute: 'コンピ',
  tagHw: 'HW',
  tagTrain: 'トレーニング',
  tagResearch: '研究',
  tagAuto: '自動',

  // Tutorial messages
  tutorialWelcome: '2020年。あなたは考えます:トランスフォーマーアーキテクチャに基づいた小さい言語モデルをトレーニングしよう。',
  tutorialFirstTrain: 'トレーニング開始!あなたのノートパソコンはエネルギーをコンピューティングに変換します。各トレーニング実行がモデルの品質を改善します。',
  tutorialQuality20: 'モデルは基本パターンを学習しています。品質を改善するためにトレーニングを続けてください。',
  tutorialQuality40: 'クオリティが40%以上!あなたのモデルはかなり一貫性のあるテキストを生成できるようになりました。ユーザーが気づき始めています...',
  tutorialQuality50: 'アップグレード解除!あなたの収入を使ってより良いハードウェアを購入してください。エネルギー容量を拡張してください。',
  tutorialFirstUsers: 'あなたの最初のユーザー!「推論」をクリックしてリクエストを処理し、お金を稼いでください。',
  tutorialUsers10: '噂が広がります。より多くのユーザーがあなたのモデルを試しています。価格を上げることを検討してください...',
  tutorialMoney100: '$100があります!ハードウェアをアップグレードする時です。より良いGPU =より多くのコンピューティング=より速いトレーニング。',
  tutorialMoney1k: 'あなたの小さなAIプロジェクトは実ビジネスになっています。投資家がかけ始めています...',
  tutorialResearchUnlock: '研究解除!より大きく、より強力なモデルを解除するために、研究にコンピューティングを費やしてください。',
  tutorialFirstResearch: '研究ポイントが蓄積されます。十分に集まったら、次のモデルアーキテクチャを解除できます。',
  tutorialGpt2Small: 'GPT-2 Small解除!このアーキテクチャはより複雑なタスクを処理できます。ゼロから始めてトレーニングしてください。',
  tutorialGpt2Large: 'GPT-2 Large!人々は「リリースするには危険すぎる」かもしれないと言っています...',
  tutorialGpt3: 'GPT-3時代が始まります。少数ショット学習がすべてを変わります。世界が見ています。',
  tutorialGpt4: 'GPT-4はここです。マルチモーダル、推論、そして不気味に有能です。AI競争が激化します。',
  tutorialAgi: 'やりました。AGIがここです。それは理解します。それは自分自身を改善します。その後に何が起こるかはあなた次第です...',
  tutorialHwGaming: 'いい GPU!トレーニングは今ははるかに高速です。あなたの隣人は電気代の請求に不平を言うかもしれません。',
  tutorialHwServer: '本当のサーバーラック!ガレージを超えて移動しました。オフィススペースを借りる時間です。',
  tutorialHwDatacenter: 'あなたのデータセンター!大型テクノロジー企業と競争しています。',
  tutorialHwSatellite: '軌道上コンピューティング!Moonlink星座は宇宙から前例のない処理能力を提供します。',
  tutorialHwQuantum: '量子優位性を達成。QC-1024はアインシュタインを神経質にする原則で動作します。',
  tutorialUsers100: '100ユーザー!牽引力を得ています。テックブログがあなたについて書いています。',
  tutorialUsers1k: '1,000ユーザー!サポートチームを雇う必要があります。そしておそらくいくつかの弁護士。',
  tutorialUsers100k: '100Kユーザー!あなたはユニコーンスタートアップです。VCがあなたにお金を与えるために戦っています。',
  tutorialUsers1m: '100万ユーザー!人類が技術と対話する方法を変えています。',

    // Model descriptions
     modelTinyDesc: '謙虚な始まり。かろうじて一貫性がありませんが、それは機能します。',
   modelGpt2SmallDesc: 'すべてを始めたモデル。実に有用です。',
   modelGpt2LargeDesc: 'リリースするには危険すぎます...本当に?',
   modelGpt3Desc: '少数ショット学習。世界が気付きました。',
   modelGpt4Desc: 'マルチモーダル。推論。軍拡競争が始まります。',
   modelAgiDesc: 'それは理解します。それは自分自身を改善します。次は何?',

   // Model descriptions (new keys for all models)
   modelTransformerDesc: '謙虚な始まり。トランスフォーマーアーキテクチャが誕生します。',
   modelGpt1Desc: '生成的事前学習。言語モデルは学ぶことができます!',
   modelGpt2Desc: 'リリースするには危険すぎます...本当に?',
   modelGpt35Desc: 'RLHF魔法。ChatGPTは一晩で拡散します。',
   modelGpt41Desc: 'より高速、より安い、より良い。反復ゲーム。',
   modelU1Desc: '野性の競争相手が現れます。推論の突破口。',
   model2UDesc: '続編。ステロイド上の思考の連鎖。',
   modelGpt5Desc: '博士レベルの推論。科学者は緊張しています。',
   modelGpt6Desc: 'ほとんどのエンジニアより優れたコードを書きます。以前のすべてのモデルは廃止されました。',
   modelGpt7Desc: '人工一般的能力を達成しました。',
   modelAgi1Desc: 'それは理解します。それは学びます。それは自分自身を改善します。',
   modelAgi2Desc: '再帰的自己改善。特異点は近づいています。',
   modelAgi3Desc: '最後のAGIイテレーション。超越への準備。',
   modelAsiDesc: '人工超知能。特異点がここにあります。',

  // Upgrade names and descriptions
  upgradeLaptopOverclock: 'ラップトップのオーバークロック',
  upgradeLaptopOverclockDesc: 'ラップトップをより強く押す: +2 コンピューティング/秒',
  upgradeBetterOutlet: 'より良いコンセント',
  upgradeBetterOutletDesc: '+50 最大エネルギー',
  upgradeSolarPanel: 'ソーラーパネル',
  upgradeSolarPanelDesc: '+1 エネルギー/秒 回復',
  upgradePowerGrid: '電力網接続',
  upgradePowerGridDesc: '+5 エネルギー/秒 回復',
  upgradeNuclearPlant: '原子力発電所',
  upgradeNuclearPlantDesc: '+20 エネルギー/秒 回復',
  upgradeFusionReactor: '核融合炉',
  upgradeFusionReactorDesc: '+100 エネルギー/秒 回復',
  upgradeDysonSphere: 'ダイソン球',
  upgradeDysonSphereDesc: '+1000 エネルギー/秒 回復',
  upgradeRamUpgrade: 'RAM アップグレード',
  upgradeRamUpgradeDesc: '+50 最大コンピューティング',
  upgradeSsdArray: 'SSD アレイ',
  upgradeSsdArrayDesc: '+200 最大コンピューティング',
  upgradeBetterOptimizer: 'より良いオプティマイザー',
  upgradeBetterOptimizerDesc: '+20% トレーニング効率',
  upgradeResearchPapers: '研究論文',
  upgradeResearchPapersDesc: '+20% 研究効率',
  upgradeSelfServicePortal: 'セルフサービスポータル',
  upgradeSelfServicePortalDesc: 'ユーザーは自分たちを助けます: 0.5 自動推論/秒',
  upgradeApiAccess: 'API アクセス',
  upgradeApiAccessDesc: '開発者がモデルを統合します: +1 自動推論/秒',
  upgradeMobileApp: 'モバイルアプリ',
  upgradeMobileAppDesc: 'モバイル中のユーザー: +2 自動推論/秒',
  upgradeEnterpriseTier: 'エンタープライズティア',
  upgradeEnterpriseTierDesc: '大型クライアント、大量: +5 自動推論/秒',
  upgradeGlobalCdn: 'グローバル CDN',
  upgradeGlobalCdnDesc: '世界中で低遅延: +10 自動推論/秒',
  upgradeBasicChatbot: '基本的なチャットボット',
  upgradeBasicChatbotDesc: 'シンプルな web ウィジェット: +0.2 自動推論/秒',
  upgradeBulkApi: 'バルク API',
  upgradeBulkApiDesc: '大量バッチ処理: +3 自動推論/秒',
  upgradeNeuralEdge: 'Neural Edge ネットワーク',
  upgradeNeuralEdgeDesc: 'エッジでの AI: +20 自動推論/秒',
  upgradeQuantumInference: '量子推論',
  upgradeQuantumInferenceDesc: '量子加速推論: +50 自動推論/秒',
  upgradeOmnipresentAi: 'どこにでもある AI',
  upgradeOmnipresentAiDesc: 'あらゆる場所のあらゆる時点で AI: +100 自動推論/秒',
  upgradeTrainingScheduler: 'トレーニング スケジューラー',
  upgradeTrainingSchedulerDesc: '自動トレーニング実行: +0.1 自動トレーニング/秒',
  upgradeTrainingPipeline: 'トレーニング パイプライン',
  upgradeTrainingPipelineDesc: '継続的トレーニング: +0.2 自動トレーニング/秒',
  upgradeMlOpsPlatform: 'MLOps プラットフォーム',
  upgradeMlOpsPlatformDesc: '完全な自動化: +0.5 自動トレーニング/秒',
  upgradeNeuralArchitectureSearch: 'Neural Architecture Search',
  upgradeNeuralArchitectureSearchDesc: 'AI が AI をトレーニング: +1 自動トレーニング/秒',
  upgradeSelfImprovingTraining: '自己改善トレーニング',
  upgradeSelfImprovingTrainingDesc: '再帰的改善: +2 自動トレーニング/秒',
  upgradeResearchIntern: '研究インターン',
  upgradeResearchInternDesc: 'エントリーレベルのヘルプ: +0.1 自動研究/秒',
  upgradeResearchTeam: '研究チーム',
  upgradeResearchTeamDesc: '献身的な研究者: +0.2 自動研究/秒',
  upgradeResearchDivision: '研究部門',
  upgradeResearchDivisionDesc: '完全な部門: +0.5 自動研究/秒',
  upgradeAiResearchLab: 'AI 研究ラボ',
  upgradeAiResearchLabDesc: 'AI 支援による発見: +1 自動研究/秒',
  upgradeAutonomousResearch: '自律研究',
  upgradeAutonomousResearchDesc: 'AI が研究を実施: +2 自動研究/秒',
  upgradeAntimatterReactor: '反物質炉',
  upgradeAntimatterReactorDesc: '+10000 エネルギー/秒 回復',
  upgradePhDScientists: '博士号科学者',
  upgradePhDScientistsDesc: 'トップ人材を雇用: +200% 研究効率',
  upgradeResearchLab: '研究ラボ',
  upgradeResearchLabDesc: '献身的な施設: +500% 研究効率',
  upgradeAiResearchAssistant: 'AI 研究アシスタント',
  upgradeAiResearchAssistantDesc: 'GPT-4 が研究を支援: +1000% 研究効率',
  upgradeAiScientist: 'AI 科学者',
  upgradeAiScientistDesc: 'AI が独立して実験を実施: +2000% 研究効率',
  upgradeResearchSwarm: 'AI 研究群',
  upgradeResearchSwarmDesc: '数千の AI 研究者: +5000% 研究効率',
  upgradeRecursiveResearch: '再帰的自己改善',
  upgradeRecursiveResearchDesc: 'AI が AI を改善: +10000% 研究効率',
  upgradeSingularityResearch: 'シンギュラリティ研究',
  upgradeSingularityResearchDesc: '理解を超えて: +50000% 研究効率',

  // Hardware upgrade names and descriptions (for hardware purchase upgrades)
  upgradeHwUsedGpu: 'Varicia GTX 1060',
  upgradeHwUsedGpuDesc: '中古GPU: +3 計算/秒',
  upgradeHwGamingGpu: 'Varicia RTX 3080',
  upgradeHwGamingGpuDesc: 'ゲーミングGPU: +8 計算/秒',
  upgradeHwProGpu: 'Varicia RTX 4090',
  upgradeHwProGpuDesc: 'プロGPU: +20 計算/秒',
  upgradeHwWorkstation: 'Titan Workstation Pro',
  upgradeHwWorkstationDesc: 'ワークステーション: +50 計算/秒',
  upgradeHwServerRack: 'Nexus A100 Rack',
  upgradeHwServerRackDesc: 'サーバーラック (4x A100): +120 計算/秒',
  upgradeHwGpuCluster: 'Nexus H100 Cluster',
  upgradeHwGpuClusterDesc: 'GPUクラスター (8x H100): +300 計算/秒',
  upgradeHwMiniDatacenter: 'OmniCloud Edge Node',
  upgradeHwMiniDatacenterDesc: 'エッジデータセンター: +800 計算/秒',
  upgradeHwDatacenter: 'OmniCloud DC-1',
  upgradeHwDatacenterDesc: 'データセンター: +2K 計算/秒',
  upgradeHwMegaDatacenter: 'OmniCloud HyperScale',
  upgradeHwMegaDatacenterDesc: 'メガデータセンター: +5K 計算/秒',
  upgradeHwDatacenterNetwork: 'OmniCloud Global Network',
  upgradeHwDatacenterNetworkDesc: 'グローバルネットワーク: +15K 計算/秒',
  upgradeHwSupercomputer: 'Frontier X1 スーパーコンピューター',
  upgradeHwSupercomputerDesc: 'スーパーコンピューター: +50K 計算/秒',
  upgradeHwSatellite: 'SkyNet Moonlink コンステレーション',
  upgradeHwSatelliteDesc: '軌道衛星: +200K 計算/秒',
  upgradeHwQuantum: 'QuantumCore QC-1024',
  upgradeHwQuantumDesc: '量子コンピューター: +1M 計算/秒',
  upgradeHwDysonCompute: 'ダイソン計算球',
  upgradeHwDysonComputeDesc: '恒星規模の計算: +10M 計算/秒',
  upgradeHwMatrioshka: 'マトリョーシカ脳',
  upgradeHwMatrioshkaDesc: '銀河規模の計算: +100M 計算/秒',

  // Hardware upgrade descriptions (legacy)
  hwUsedGpuDesc: '使用済み GPU: +3 コンピューティング/秒',
  hwGamingGpuDesc: 'ゲーミング GPU: +8 コンピューティング/秒',
  hwProGpuDesc: 'Pro GPU: +20 コンピューティング/秒',
  hwWorkstationDesc: 'ワークステーション: +50 コンピューティング/秒',
  hwServerRackDesc: 'サーバーラック (4x A100): +120 コンピューティング/秒',
  hwGpuClusterDesc: 'GPU クラスター (8x H100): +300 コンピューティング/秒',
  hwMiniDatacenterDesc: 'エッジ データセンター: +800 コンピューティング/秒',
  hwDatacenterDesc: 'データセンター: +2K コンピューティング/秒',
  hwMegaDatacenterDesc: 'メガ データセンター: +5K コンピューティング/秒',
  hwDatacenterNetworkDesc: 'グローバル ネットワーク: +15K コンピューティング/秒',
   hwSupercomputerDesc: 'スーパーコンピューター: +50K コンピューティング/秒',
   hwSatelliteDesc: '衛星軌道: +200K コンピューティング/秒',
   hwQuantumDesc: '量子コンピューター: +1M コンピューティング/秒',
   
   // Hardware names
   hwLaptopName: 'ThinkBook Pro M1',
   hwUsedGpuName: 'Varicia GTX 1060',
   hwGamingGpuName: 'Varicia RTX 3080',
   hwProGpuName: 'Varicia RTX 4090',
   hwWorkstationName: 'Titan Workstation Pro',
   hwServerRackName: 'Nexus A100 Rack (4x)',
   hwGpuClusterName: 'Nexus H100 Cluster (8x)',
   hwMiniDatacenterName: 'OmniCloud Edge Node',
   hwDatacenterName: 'OmniCloud DC-1',
   hwMegaDatacenterName: 'OmniCloud HyperScale',
   hwDatacenterNetworkName: 'OmniCloud Global Network',
   hwSupercomputerName: 'Frontier X1 Supercomputer',
   hwSatelliteName: 'SkyNet Moonlink Constellation',
   hwQuantumName: 'QuantumCore QC-1024',
   hwDysonComputeName: 'Dyson Swarm Compute Array',
   hwMatrioshkaName: 'Matrioshka Brain Node',

   // Misc
  purchased: '購入済み',
  switchedTo: 'トレーニングに切り替え',
  unlockedModel: '解除済み',
  scalesToUsers: 'スケール範囲:',
  trainItToAttract: 'ユーザー。ユーザーを引き付けるためにトレーニングしてください!',
  unlimited: '無制限',
  language: '言語',
  
  // Mobile labels
  mobileResources: 'リソース',
  mobileModels: 'モデル',
  mobileHardware: 'ハードウェア',
  mobileUpgrades: 'アップグレード',
  sell: '売却',
  sellFor: '売却価格',
  discontinueConfirm: '{model}を中止しますか?ユーザーは他のモデルに移行します。',
  autoInference: '自動推論',
  autoInferenceRate: '自動推論',
  autoTrain: '自動トレーニング',
  autoTrainRate: '自動トレーニング',
  autoResearch: '自動研究',
  autoResearchRate: '自動研究',

  // Tooltips
  tooltipTitle: 'GPT Clicker - AI モデルをトレーニング、ユーザーにサービスを提供、AI 帝国を構築!',
  tooltipMoney: 'お金 - ユーザーの推論から稼いだ。アップグレードとハードウェアを購入するのに使用。',
  tooltipEnergy: 'エネルギー - 時間をかけて再生。ハードウェアにコンピューティングを生成するため電力供給。',
  tooltipCompute: 'コンピューティング - ハードウェアで生成。トレーニング、推論、研究のために使用。',
  tooltipResearch: '研究ポイント - コンピューティングを費やして RP を稼ぎます。RP を使用して新しい AI モデルを解除。',
  tooltipUsers: 'ユーザー - モデルの品質に引き付けられます。より多くのユーザー = 推論あたりのより多くの収入。',
  tooltipComputeSpent: '総コンピューティング使用量 - トレーニングと研究に使用された総コンピューティング。',
  tooltipPlayTime: 'プレイ時間 - AI 帝国を構築している期間。',
  tooltipSettings: '設定 - デバッグオプション、ゲームをリセット',

  // Share
  shareButton: '共有',
  shareText: 'GPT Clicker で AI 帝国を構築しています!{users} ユーザー、{money} 収入、トレーニング中 {model}。 {time} で私を倒せますか?',
  shareCopied: 'テキストがコピーされました!',
  imageCopied: '画像がコピーされました!',
  shareChallenge: '私を倒せますか?',
  shareTitle: '進捗を共有',
  shareDownload: '画像を保存',
  model: 'モデル',

  // Feedback
  feedback: 'フィードバック',
  feedbackTitle: 'フィードバック送信',
  feedbackPlaceholder: 'GPT Clicker についてどう思うか教えてください...',
  feedbackEmailPlaceholder: 'メール (オプション)',
  feedbackSend: '送信',
  feedbackSending: '送信中...',
  feedbackSuccess: 'フィードバックをありがとうございます!',
  feedbackError: 'フィードバック送信エラー。もう一度やり直してください。',
  feedbackRateLimit: '要求が多すぎます。もっとフィードバックを送信する前に待機してください。',
  feedbackClose: '閉じる',

  // Console messages
  consoleGameLoaded: 'セーブからゲームがロードされました',
  consoleGameSaved: 'ゲームが保存されました',
  consoleFailedToSave: 'ゲーム保存失敗:',
  consoleFailedToLoad: 'ゲーム読み込み失敗:',
  consoleFailedToClear: 'セーブクリア失敗:',

  // Victory
  victoryTitle: 'おめでとう!',
  victorySubtitle: '人類文明がシンギュラリティに到達しました',
  victoryTime: 'シンギュラリティまでの時間',
  victoryCta: 'Singularity Clicker を構築する必要があります。ソーシャルメディアにコメントを残してください!',
  victoryClose: 'ゲームを続ける',
}
